<template>
  <ul class="search-keyword-card-list">
    <li
      v-for="item in items"
      :key="item.key"
    >
      <div class="search-keyword-card">
        <BaseLink
          class="search-keyword-card-thumbnail"
          aria-hidden="true"
          v-bind="baseLinkProps(item)"
          :show-icon="false"
        >
          <UiImageSelection :type="item.type"
            :image="item.image"
            :appearance="{
              borderRadius: 'medium',
            }"
            image-usage="thumbnail"
          />
          <ListEditIcon :item="item" field="image" :editstate="editstate" />
        </BaseLink>

        <div class="search-keyword-card-body">
          <BaseLink
            v-if="ls(item.title)"
            v-bind="baseLinkProps(item)"
            class="search-keyword-card-title"
          >
            <span class="title-text">
              {{ ls(item.title) }}
            </span>
            <BaseIcon
              class="title-icon"
              name="mdi/magnify"
              size="size-4"
            />
          </BaseLink>

          <div class="search-keyword-card-meta">
            <p class="meta-text">
              {{ ls(item.description) }}
            </p>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const {
  baseLinkProps,
} = useCurationListView(props.editstate, props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.search-keyword-card-list {
  width: 100%;
  gap: 1.5rem 2rem;
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @include is-tablet {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include is-desktop {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.search-keyword-card {
  display: flex;
  gap: 1rem;
}

.search-keyword-card-thumbnail {
  flex: 0 0 40%;
  max-width: 9.75rem;
  aspect-ratio: 3 / 2;
  width: 100%;
  height: 100%;
  overflow: hidden;

  :deep(img),
  :deep(canvas) {
    width: 100%;
    height: 100%;
    object-fit: contain !important;
  }
}

.search-keyword-card-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.search-keyword-card-title {
  .title-text {
    vertical-align: middle;
    font-weight: bold;
    font-size: $size-6;

    & + * {
      margin-left: 0.125rem;
    }
  }
  .title-icon {
    vertical-align: middle;
  }
}

.search-keyword-card-meta {
  .meta-text {
    font-size: $size-7;
    color: $jps-gray-700;
  }
}
</style>